import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./Popup.scss"

class Popup extends Component {
  constructor() {
    super()
    this.state = {
    }
    this.close = this.close.bind(this);
    this.closeAndChoose = this.closeAndChoose.bind(this);
  }
  close() {
    this.props.triggerPopup();
  }
  closeAndChoose() {
    this.close();
    this.props.chooseMeal(this.props.popupData.data.ID);
  }
  render() {
    const image = {
      backgroundImage: `${(this.props.popupData.data.Image ? `url(./static/images/manot/${this.props.popupData.data.Image}.jpg)` : "")}`
    }
    return (
      <div>
        <div className={`popupfade${(this.props.isPoping ? " active" : "")}`} onClick={this.close}></div>
        <section className={`section section-popup${(this.props.isPoping ? " active" : "")}${(this.props.popupData.isChoosen === true ? "" : (this.props.popupData.isChoosen === false ? "" : " error"))}`}>
          <div className="padding">
            <div className="container">
              <div className="close" onClick={this.close}></div>
              <div className="headline">
                <div className="head">{this.props.popupData.data.Title}</div>
                <div className="desc">{`${this.props.popupData.data.City}, ${this.props.popupData.data.CityAddress}`}</div>
                <div className={`image${(this.props.popupData.data.Image ? " filled" : "")}`}>
                  <div className="image-wrapper">
                    <div className="bgimage" style={image}></div>
                    <div className="mask"></div>
                  </div>
                </div>
                <div className="text">
                  <div className="wrapper" dangerouslySetInnerHTML={{ __html: this.props.popupData.data.Describe }}>
                  </div>
                </div>
                <div className={`button${(this.props.popupData.isChoosen === true ? " active" : (this.props.popupData.isChoosen === false ? "" : " hide"))}`} onClick={() => { push(`falafel - ${(!this.state.isChoosen ? "Add to List" : "Removed From List")}`, "Pic"); this.closeAndChoose() }}>
                  <div className="button-text">
                    {`${(this.props.popupData.isChoosen ? "בטל בחירה" : "בחירה")}`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.js